import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { ZoneGroupResponse } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { GridColumnHelper } from '../utils';
import { ICONS } from '../icons';
import { ZoneGroupDetailsSectionHandler } from './details.section';
import { AssetGroupingService } from 'app/services';
import { RegisterEntityHandler } from '../../entities';

@RegisterEntityHandler('zonegroup')
@Injectable()
export class ZoneGroupHandler extends EntityHandler<ZoneGroupResponse> {

    currentEntity: ZoneGroupResponse;

    constructor(
        admin: AdminEditorService,
        private grouping: AssetGroupingService
    ) {
        super(admin);
        this.listMode = 'tree';
    }

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        // we can't paginate tree items, so hard code a limit of 250 and hope it's enough
        offset = 0;
        limit = 250;
        return this.admin.getCached(`listZoneGroups/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listZoneGroups(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'zonegroup',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.ZONEGROUPS'),
        }));
    }

    getEntity(id: string): Promise<ZoneGroupResponse> {
        return this.admin.getCached(`getZoneGroup/${id}`, api => api.entities.getZoneGroup(id), 10).then(result => {
            this.currentEntity = result;
            return result;
        });
    }

    createEntity(ownerId: string, entity: any): Promise<ZoneGroupResponse> {
        entity.ownerId = ownerId;
        this.grouping.clear(); // clear our grouping cache after an update
        return this.admin.applyUpdate(api => api.entities.createZoneGroup(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        if (state === 'deleted') {
            this.grouping.clear(); // clear our grouping cache after an update
            this.currentEntity = null;
            return this.admin.applyUpdate(api => api.entities.deleteZoneGroup(entity.id));
        }
        return Promise.reject('Only deletion supported');
    }    

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ZONEGROUP.COLUMNS');
        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('name', 'NAME', (row) => {
                return row.folder ? ICONS.folder : ICONS.zonegroup;
            }),
            // grid.TextColumn('zones', 'ZONES', 80), TODO: add back when the backend can return a count 
            grid.TimeAgoColumn('entity.modifiedDate', 'MODIFIED'),
        ];
        return Promise.resolve(columns);
    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<ZoneGroupResponse>[]> {
        // const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.ZONE.COLUMNS');
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new ZoneGroupDetailsSectionHandler(this.admin, ownerId, this.grouping),
            ],
        }, // TODO: add zones list
        ]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: any, sections: FormSectionHandler<ZoneGroupResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'zonegroup',
            entity: {
                parent: this.currentEntity ? { id: this.currentEntity.id, name: this.currentEntity.name } : null,
            },
            sections: [
                new ZoneGroupDetailsSectionHandler(this.admin, ownerId, this.grouping),
            ],
        });
    }

}













